import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { dummyImage } from './image';


export interface DrugInfo {
  image: string;
  fg: string;
  drugName: string;
  strength: string;
  unit: string;
  drugNumber: string;
  mfg: string;
}


@Component({
  selector: 'app-import-wizard-pill-id-details',
  standalone: false,
  templateUrl: './import-wizard-pill-id-details.component.html',
  styleUrl: './import-wizard-pill-id-details.component.scss'
})

export class ImportWizardPillIdDetailsComponent implements OnInit{
  defaultImage = dummyImage;

  constructor(public dialogRef: MatDialogRef<ImportWizardPillIdDetailsComponent>){

  }
  dataDummy: DrugInfo[] = [
    {
      image: this.defaultImage,
      fg:'fg1',
      drugName: 'LIPITOR',
      strength: '10',
      unit: 'mg',
      drugNumber: '0071015524',
      mfg: 'Pfizer'
    },
    {
      image: this.defaultImage,
      fg:'fg1',
      drugName: 'LIPITOR',
      strength: '10',
      unit: 'mg',
      drugNumber: '0071015510',
      mfg: 'Pfizer'
    },
    {
      image: this.defaultImage,
      fg:'fg1',
      drugName: 'LIPITOR',
      strength: '10',
      unit: 'mg',
      drugNumber: '0071015550',
      mfg: 'Pfizer'
    }
  ];
  drugs:DrugInfo[]=[];

  ngOnInit(): void {
  }
  
  addNewPillID() {
    // Implement add functionality
  }

  changePillID() {
    // Implement change functionality
  }

  removePillID() {
    // Implement remove functionality
  }
}
